module.exports = __webpack_public_path__ + "img/botconversa.59b94afb.png";